var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c(
        "div",
        {
          staticClass: "form-item",
          class: [_vm.isInvalid ? "is-invalid" : ""],
        },
        [
          _c("Label", {
            attrs: {
              item: _vm.item,
              "is-invalid": _vm.isInvalid,
              errors: _vm.errors,
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "scale" }, [
            _c(
              "div",
              {
                on: {
                  mouseleave: function ($event) {
                    _vm.hover = 0
                  },
                },
              },
              _vm._l(Number(_vm.item.data.scaleSteps), function (n) {
                return _c(
                  "span",
                  {
                    key: n,
                    on: {
                      mouseenter: function ($event) {
                        _vm.hover = n
                      },
                      click: function ($event) {
                        return _vm.select(n)
                      },
                    },
                  },
                  [
                    _c("i", {
                      class: [
                        `fa-${_vm.item.data.scaleIcon}`,
                        _vm.iconStyle(n),
                      ],
                    }),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "scale-min-label hasi18n" }),
            _vm._v(" "),
            _c("div", { staticClass: "scale-max-label hasi18n" }),
          ]),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: _vm.item.data.id },
            domProps: { value: _vm.selected },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }